import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { Search } from 'lucide-react';
import { ThemeToggle } from './ThemeToggle';
import { UserMenu } from './UserMenu';

/** route -> { title, crumb } map (from the maquette). */
const SCREEN_META: Record<string, { title: string; crumb: string }> = {
  '/dashboard': { title: 'Cuadro de mando · SEAPA', crumb: 'Inicio' },
  '/operativa': { title: 'Hub operativo', crumb: 'Operativa' },
  '/avisos': { title: 'Avisos', crumb: 'Operativa' },
  '/altaAviso': { title: 'Registrar aviso', crumb: 'Operativa / Avisos' },
  '/asistencias': { title: 'Asistencias', crumb: 'Gestión' },
  '/accidentes': { title: 'Accidentes', crumb: 'Gestión' },
  '/vehiculos': { title: 'Vehículos', crumb: 'Gestión' },
  '/estadisticas': { title: 'Estadísticas', crumb: 'Gestión' },
  '/usuarios': { title: 'Usuarios', crumb: 'Sistema' },
  '/catalogos': { title: 'Catálogos', crumb: 'Sistema' },
  '/configuracion': { title: 'Configuración', crumb: 'Sistema' },
};

function useClock() {
  const [now, setNow] = useState(() => new Date());
  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 15_000);
    return () => clearInterval(id);
  }, []);
  return now.toLocaleTimeString('es-ES', { hour: '2-digit', minute: '2-digit' });
}

function MiniStat({
  value,
  label,
  accent,
}: {
  value: string;
  label: string;
  accent?: boolean;
}) {
  return (
    <div className="flex items-baseline gap-[5px] font-mono">
      <b className={accent ? 'text-[14px] text-c-warn' : 'text-[14px]'}>{value}</b>
      <span className="text-[8.5px] uppercase tracking-[.5px] text-c-mid">
        {label}
      </span>
    </div>
  );
}

export function Topbar() {
  const { pathname } = useLocation();
  const meta = SCREEN_META[pathname] ?? { title: '', crumb: '' };
  const clock = useClock();

  return (
    <header className="flex h-[54px] flex-none items-center gap-[16px] border-b border-c-line bg-c-bg px-[18px] text-c-text">
      <div className="font-mono text-[10px] text-c-dim">{meta.crumb} /</div>
      <div className="text-[14px] font-bold">{meta.title}</div>

      {/* ghost global search */}
      <div className="ml-[8px] flex max-w-[340px] flex-1 items-center gap-[7px] rounded-[7px] border border-c-line px-[12px] py-[7px] font-mono text-[10.5px] text-c-dim">
        <Search size={13} strokeWidth={1.8} />
        <span className="truncate">buscar aviso, dirección, paciente…</span>
        <span className="ml-auto">⌘K</span>
      </div>

      {/* right cluster */}
      <div className="ml-auto flex items-center gap-[16px]">
        <MiniStat value="5" label="avisos hoy" />
        <MiniStat value="4:38" label="t. resp." />
        <MiniStat value="1/2" label="libres" accent />
        <ThemeToggle />
        <div className="h-[24px] w-px bg-c-line" />
        <div className="font-mono text-[13px] font-bold">{clock}</div>
        <UserMenu />
      </div>
    </header>
  );
}
